function readMore() {
    const readMoreButton = document.querySelector('.read-more-button');
    const description = document.querySelector('.articleLookbook-des');
    $(document).on('click', '.read-more-button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('clicked');
        if (description.classList.contains('is-expanded')) {
            description.classList.remove('is-expanded');
            readMoreButton.textContent = 'Read More';
        } else {
            description.classList.add('is-expanded');
            readMoreButton.textContent = 'Read less';
        }
    });
}
readMore();